import type { ReactNode } from 'react';

/** ブラウザタブ（index.html）と揃えた製品名。 */
const PRODUCT_NAME = 'microapp基盤';

/**
 * ブランドマーク。bpmn.ioのロゴは使えないので自前のSVGにしている。
 * AppShellとWorkspaceShellの両方が同じマークを出すため、ここから公開する。
 * 形を変えるときはfavicon（src/favicon.svg）も揃える。
 */
export function BrandMark() {
  return (
    <svg viewBox="0 0 24 24" width="21" height="21" aria-hidden="true" focusable="false">
      <rect
        x="1.6"
        y="3"
        width="9"
        height="7"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <rect
        x="13.4"
        y="14"
        width="9"
        height="7"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M6.1 10v4.4a2 2 0 0 0 2 2h5.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export interface AppShellProps {
  /** ブランドから戻る先（Workspace一覧）。URLの組み立てはrouterの責務。 */
  brandHref: string;
  /** 渡したときだけヘッダー右端にログアウトを出す。認証が無効なlocalでは渡さない。 */
  onLogout?: () => void;
  children: ReactNode;
}

/**
 * microapp詳細まわりの外枠。暗色ヘッダー＋明色stageの2領域。
 * 業務ロジックもルーティングも持たず、渡された断片を配置するだけ。
 */
export function AppShell({ brandHref, onLogout, children }: AppShellProps) {
  return (
    <div className="app-shell">
      <header className="app-shell-header">
        <a className="app-shell-brand" href={brandHref}>
          <BrandMark />
          <span>{PRODUCT_NAME}</span>
        </a>
        {onLogout === undefined ? null : (
          <button type="button" className="nav-item app-shell-logout" onClick={onLogout}>
            ログアウト
          </button>
        )}
      </header>
      <main className="app-shell-stage">{children}</main>
    </div>
  );
}
